<template>
  <v-layout class="registration" align-center justify-center>
    <v-flex xs12 sm8 md4>
      <v-card class="elevation-3" xs12 sm8 md4>
        <v-layout align-center justify-center>
          <img src="../assets/largeicon.png" alt="logo" class="logo">
        </v-layout>
        <v-card-text>
          <v-form ref="form" class="registration-form">
            <v-text-field prepend-icon="person"
              name="email"
              label="Email"
              type="text"
              :rules="[rules.required]"
              v-model="email"
            ></v-text-field>
            <v-text-field prepend-icon="lock"
              name="password"
              label="Password"
              type="password"
              :rules="[rules.required, rules.min]"
              v-model="password"
            ></v-text-field>
            <v-text-field prepend-icon="lock"
              name="confirmation"
              label="Confirm"
              type="password"
              v-model="confirmation"
              :rules="[rules.required, rules.passwordMatch]"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn block
            color="primary"
            @click="register()"
            :disabled='!isComplete'
            >
            Regsiter now
          </v-btn>
        </v-card-actions>

        <v-card-text>
          <v-layout row align-center justify-center>
            <v-btn flat
              color="info"
              grey-lighten
              to="/login"
              >
              I think I already have an account
            </v-btn>
          </v-layout>
          <v-layout row align-center justify-center>
            <v-btn flat to="/forgot-password" >
              Reset your password
            </v-btn>
          </v-layout>
        </v-card-text>

        <v-alert :value="error" type="warning" class="mt-3" >
          {{ error }}
        </v-alert>
        <v-alert :value="success" type="success" class="mt-3" >
          {{ success }}
        </v-alert>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import regoService from '@/services/registration'

  export default {
    name: 'registration',
    props: [],

    data () {
      return {
        error: null,
        success: null,
        email: null,
        password: null,
        confirmation: null,
        rules: {
          required: v => !!v || 'Required',
          min: v => (v && (v.length >= 8)) || 'Min 8 characters',
          passwordMatch: (v) => {
            let test = '^' + v
            if (this.password && this.password.match(new RegExp(test))) {
              return true
            } else {
              return 'Passwords don\'t match'
            }
          }
        }
      }
    },

    watch: {
    },

    computed: {
      isComplete () {
        return this.email && this.password && this.confirmation && (this.password === this.confirmation)
      }
    },

    mounted () {
    },

    methods: {
      register () {
        if (this.$refs.form.validate()) {
          regoService.create(
            (data) => {
              this.success = 'Please check your inbox for an account confirmation email'
            },
            (err) => {
              if (err.response && err.response.status === 422) {
                this.error = 'Your account could not be created'
              }
            },
            this.email,
            this.password
          )
        }
      }
    }
  }
</script>

<style lang="css" scoped>
.v-btn.v-btn--flat{
  width:100%;
}
.v-btn.v-btn--flat:hover:before{
  background-color: #fff;
  box-shadow: 0 3px 3px -2px rgba(0,0,0,.6),0 3px 4px 0 rgba(0,0,0,.48),0 1px 8px 0 rgba(0,0,0,.44);
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue